import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCam = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 16.5L6.69611 16.9179C5.50352 18.5577 4.90722 19.3776 4.92851 20.0622C4.94703 20.6581 5.23046 21.2146 5.7015 21.5801C6.24263 22 7.25644 22 9.28406 22H14.7159C16.7436 22 17.7574 22 18.2985 21.5801C18.7695 21.2146 19.053 20.6581 19.0715 20.0622C19.0928 19.3776 18.4965 18.5577 17.3039 16.9179L17 16.5M20 10C20 14.4183 16.4183 18 12 18C7.58172 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCam;
